import {SvgIcon, SvgIconProps} from "@mui/material";
import React from "react";

export const NotificationsIcon: React.FC<SvgIconProps> = (props) => (
    <SvgIcon sx={{fill: "none", strokeWidth: "1.5", ...props.sx}} viewBox="0 0 18 18">
        <path
            d="M10.3456 16.2027C10.2088 16.4452 10.0125 16.6465 9.7764 16.7864C9.54025 16.9263 9.27252 17 9 17C8.72748 17 8.45975 16.9263 8.2236 16.7864C7.98746 16.6465 7.79119 16.4452 7.65444 16.2027M13.6667 5.80085C13.6667 4.52759 13.175 3.30647 12.2998 2.40614C11.4247 1.5058 10.2377 1 9 1C7.76232 1 6.57534 1.5058 5.70017 2.40614C4.825 3.30647 4.33333 4.52759 4.33333 5.80085C4.33333 11.4018 2 13.0021 2 13.0021H16C16 13.0021 13.6667 11.4018 13.6667 5.80085Z"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </SvgIcon>
);
